<template>
  <!-- Información del usuario miembro -->
  <v-container>
    <v-row>
      <v-col
        v-for="(indicator, i) in getMemberIndicatorsComputed"
        :key="indicator.id + '_' + i"
        :cols="$vuetify.breakpoint.mdAndDown ? '12' : 'auto'"
      >
        <v-card
          v-if="indicator.content && !indicator.disabled"
          min-width="200"
          style="border-radius: 15px"
          :color="
            indicator.title === 'Estado'
              ? homologateStatusWithColor(indicator.content).color
              : indicator.color
          "
          :elevation="0"
        >
          <v-list-item class="info-title"> {{ indicator.title }} </v-list-item>
          <v-list-item
            class="d-flex justify-end text info-content"
            :class="
              indicator.title === 'Fecha de Vencimiento' && isInIndulgencePeriod
                ? 'red--text text--darken-4'
                : ''
            "
            v-if="indicator.title != 'Miembro de'"
          >
            {{
              indicator.title === 'Estado'
                ? homologateStatusWithColor(indicator.content).status
                : indicator.content
            }}
          </v-list-item>

          <v-list-item
            class="d-flex justify-end text info-content"
            v-else-if="indicator.content && indicator.content != 'NOT_ASSIGNED'"
          >
            <v-avatar>
              <img
                :src="indicator.content"
                alt="John"
                class="org-img"
              >
            </v-avatar>
          </v-list-item>
        </v-card>


      </v-col>
      <v-col
        class="d-flex"
        :class="$vuetify.breakpoint.smAndUp ? 'align-end' : 'justify-center'"
      >
        <v-tooltip
          open-on-hover
          bottom
          activator="#constancyButton"
          max-width="250"
        >
          <span
            >Si tiene problemas para descargar la constancia, le recomendamos
            intentar desde una ventana incógnito.</span
          >
        </v-tooltip>

        <div id="constancyButton" v-if="user.validationStatus == 'ACTIVE'">
          <v-btn
            color="#1B273E"
            class="mx-2 white--text font-weight-bold"
            rounded
            @click.prevent="downloadConstancy()"
          >
            Constancia de membresía
            <v-icon small class="ml-2">mdi-download</v-icon>
          </v-btn>
        </div>
      </v-col>

      <v-col
        v-if="
          this.user.headOffice.id == '62b622c66a7441ae20159d7d' ||
          this.user.headOffice.id == '6297b0fec7bf8b6f826313be'
        "
        class="pt-6"
      >
        <v-sheet>
          <v-btn
            elevation="1"
            v-bind="$attrs"
            v-on="$on"
            style="
              background-color: #70b578;
              border-radius: 50px;
              font-weight: bold;
              color: white;
            "
            class="d-flex justify-center align-center"
            @click="redirectToValoresAMPI"
          >
            Ir a Valores AMPI
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row v-if="isInIndulgencePeriod">
      <v-col>
        <v-row class="my-0 mx-2">
          <v-icon color="red darken-3">mdi-alert</v-icon>
          <span class="font-weight-bold red--text text--darken-3">
            Estás en días de tolerancia
          </span>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import { homologateStatusWithColor } from '@/common/hook/useHelper';
import { isImefOrganization } from '../../share/imef';
import { isClub51Organization } from '../../share/validateOrganization';

export default {
  data() {
    return {
      indicators: {
        status: {
          title: 'Estado',
          content: '',
          color: '#9bf4d6',
          disabled: false,
        },
        expiration_date: {
          title: 'Fecha de Vencimiento',
          content: '',
          color: '#ade1ef',
          disabled: false,
        },
        member_from: {
          title: 'Miembro de',
          content: '',
          color: '#b6dae6',
          disabled: false,
        },
      },
      profileCompany: '',
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('membershipProfile', ['userMembership']),
    isInIndulgencePeriod() {
      const nationalDetails = this.user?.affiliation?.national?.details || [];
      let nationalInactivationDate = null;
      if (nationalDetails.length > 0) {
        nationalInactivationDate =
          nationalDetails[0]?.affiliateInformation?.inactiveDate || null;
      }

      const localDetails = this.user?.affiliation?.national?.details || [];
      let localInactivationDate = null;
      if (localDetails.length > 0) {
        localInactivationDate =
          localDetails[0]?.affiliateInformation?.inactiveDate || null;
      }

      if (nationalDetails.length <= 0 && localDetails.length <= 0) return false;

      let nationalIndulgence = true;
      let localIndulgence = true;

      if (nationalInactivationDate) {
        nationalIndulgence = new Date(nationalInactivationDate) < new Date();
      }

      if (localInactivationDate) {
        localIndulgence = new Date(localInactivationDate) < new Date();
      }

      return nationalIndulgence && localIndulgence;
    },

    getMemberIndicatorsComputed() {
      const indicatorsIndex = Object.keys(this?.indicators) || [];
      return indicatorsIndex.map((key) => {
        return {
          id: key,
          ...this.indicators[key],
        };
      });
    },
  },
  methods: {
    ...mapActions('member', ['fetchMemberStatus']),
    ...mapActions('user', ['realoadUserData']),
    ...mapActions('membershipProfile', ['getMembershipById']),
    homologateStatusWithColor,
    isImefOrganization,
    isClub51Organization,

    redirectToValoresAMPI() {
      window.open('https://valoresampi.mx/', '_blank');
    },
    async downloadConstancy() {
      try {
        const response = await this.axios({
          method: 'POST',
          url: '/users/certificate',
          data: {
            userId: this.user._id,
          },
        });
        if (response?.data) {
          window.location.href = response.data?.constancy || '';
        }
      } catch (error) {
        console.log(error);
      }
    },
    getMemberIndicators() {
      // buscar dentro del array aquella posición que contenga el formattedName y retorna su valor
      const getMemberDataValue = (memberData = [], formattedName = '') => {
        let index = [...memberData].findIndex(
          (elem) => elem.formattedName === formattedName
        );
        if (index === -1) {
          return '';
        }
        return memberData[index].value;
      };

      this.indicators.status.content = this.user.validationStatus;
      this.indicators.member_from.content = this.user.organizationProfilePicture;

      let inactivationDate = '';

      if (this.user.affiliation && this.user.affiliation.national) {
        if (this.user.affiliation.national.details) {
          const { affiliateInformation } =
            this.user.affiliation.national.details[0];
          if (affiliateInformation?.inactiveDate) {
            inactivationDate = moment(affiliateInformation.inactiveDate).format(
              'MMMM DD YYYY'
            );
          }
        }
      }

      if (this.user.affiliation && this.user.affiliation.local) {
        if (this.user.affiliation.local.details) {
          const { affiliateInformation } =
            this.user.affiliation.local.details[0];
          if (
            affiliateInformation.inactiveDate &&
            affiliateInformation.inactiveDate < inactivationDate
          ) {
            inactivationDate = moment(affiliateInformation.inactiveDate).format(
              'MMMM DD YYYY'
            );
          }
        }
      }

      this.indicators.expiration_date.content = inactivationDate;
    },

    disableExpirationDateStatus() {
      this.indicators.expiration_date.disabled = this.isClub51Organization(this.user._id, this.user.headOffice._id) || false
    }
  },
  async mounted() {
    console.log(this.userMembership);
    if (!!this.userMembership) {
      this.profileCompany = this.userMembership?.organization?.company || 'N/A';
    } else {
      this.profileCompany = this.user.branch;
    }

    this.getMemberIndicators();
    this.disableExpirationDateStatus();
  },
};
</script>

<style scoped>
.info-title {
  color: #1e2e3e;
  font-weight: 600;
}

.info-content {
  color: #1e2e3e;
  font-weight: 900;
  min-height: 64px;
}

.org-img {
  object-fit: fill;
}
</style>
